import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Button } from '@/ui'

interface Props {
  children: ReactNode
}
interface State {
  error: Error | null
}

/** Last-resort boundary so a render error shows a recoverable screen, not a blank page. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error', error, info)
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
          <h1 className="text-lg font-semibold text-tg-text">Что-то сломалось</h1>
          <p className="max-w-sm text-sm text-tg-hint">{this.state.error.message}</p>
          <Button onClick={() => window.location.reload()}>Перезагрузить</Button>
        </div>
      )
    }
    return this.props.children
  }
}
